export const IMG = {
  cafeOwner:
    "https://images.unsplash.com/photo-1551529563-fce9529e67ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxyZXN0YXVyYW50JTIwb3duZXIlMjBwaG9uZXxlbnwwfHx8fDE3ODY1NjE3ODJ8MA&ixlib=rb-4.1.0&q=85",
  phoneApps:
    "https://images.unsplash.com/photo-1675352161865-27816c76141a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxzb2NpYWwlMjBtZWRpYSUyMHBsYW5uaW5nfGVufDB8fHx8MTc4NjU2MTc4Mnww&ixlib=rb-4.1.0&q=85",
  coffeeShop:
    "https://images.unsplash.com/photo-1567880905822-56f8e06fe630?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxhZXN0aGV0aWMlMjBjb2ZmZWUlMjBzaG9wfGVufDB8fHx8MTc4NjU2MTc4Mnww&ixlib=rb-4.1.0&q=85",
  dinner:
    "https://images.unsplash.com/photo-1565895405140-6b9830a88c19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwcGxhdGVkJTIwZGlzaCUyMHRhYmxlfGVufDB8fHx8MTc4NjU2MjA4MHww&ixlib=rb-4.1.0&q=85",
  dinnerAlt:
    "https://images.unsplash.com/photo-1565895405227-31cffbe0cf86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxyZXN0YXVyYW50JTIwcGxhdGVkJTIwZGlzaCUyMHRhYmxlfGVufDB8fHx8MTc4NjU2MjA4MHww&ixlib=rb-4.1.0&q=85",
  salad:
    "https://images.unsplash.com/photo-1565895405137-3ca0cc5088c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxyZXN0YXVyYW50JTIwcGxhdGVkJTIwZGlzaCUyMHRhYmxlfGVufDB8fHx8MTc4NjU2MjA4MHww&ixlib=rb-4.1.0&q=85",
  barber:
    "https://images.unsplash.com/photo-1647140655214-e4a2d914971f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxiYXJiZXIlMjBzaG9wJTIwaGFpcmN1dHxlbnwwfHx8fDE3ODY1NjIwODV8MA&ixlib=rb-4.1.0&q=85",
  barberAlt:
    "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxiYXJiZXIlMjBzaG9wJTIwaGFpcmN1dHxlbnwwfHx8fDE3ODY1NjIwODV8MA&ixlib=rb-4.1.0&q=85",
  salon:
    "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxiZWF1dHklMjBzYWxvbiUyMHRyZWF0bWVudHxlbnwwfHx8fDE3ODY1NjIwOTB8MA&ixlib=rb-4.1.0&q=85",
  salonAlt:
    "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxiZWF1dHklMjBzYWxvbiUyMHRyZWF0bWVudHxlbnwwfHx8fDE3ODY1NjIwOTB8MA&ixlib=rb-4.1.0&q=85",
  gym:
    "https://images.unsplash.com/photo-1641337221253-fdc7237f6b61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxneW0lMjB3b3Jrb3V0JTIwdHJhaW5pbmd8ZW58MHx8fHwxNzg2NTYyMDk2fDA&ixlib=rb-4.1.0&q=85",
  gymAlt:
    "https://images.unsplash.com/photo-1548690312-e3b507d8c110?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxneW0lMjB3b3Jrb3V0JTIwdHJhaW5pbmd8ZW58MHx8fHwxNzg2NTYyMDk2fDA&ixlib=rb-4.1.0&q=85",
  latte:
    "https://images.unsplash.com/photo-1770123024506-e24e3e55db31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxsYXR0ZSUyMGFydCUyMGNvZmZlZSUyMHNob3AlMjBjb3VudGVyfGVufDB8fHx8MTc4NjU2MjEwMXww&ixlib=rb-4.1.0&q=85",
  latteAlt:
    "https://images.unsplash.com/photo-1635902981695-4bb5b00f5713?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxsYXR0ZSUyMGFydCUyMGNvZmZlZSUyMHNob3AlMjBjb3VudGVyfGVufDB8fHx8MTc4NjU2MjEwMXww&ixlib=rb-4.1.0&q=85",
  barista:
    "https://images.unsplash.com/photo-1764023874653-f1bc06f59022?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxsYXR0ZSUyMGFydCUyMGNvZmZlZSUyMHNob3AlMjBjb3VudGVyfGVufDB8fHx8MTc4NjU2MjEwMXww&ixlib=rb-4.1.0&q=85",
  car:
    "https://images.unsplash.com/photo-1620584898989-d39f7f9ed1b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxjYXIlMjBkZXRhaWxpbmclMjBzaGluZXxlbnwwfHx8fDE3ODY1NjIxMDh8MA&ixlib=rb-4.1.0&q=85",
  carAlt:
    "https://images.unsplash.com/photo-1708805282683-50a060eba80f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxjYXIlMjBkZXRhaWxpbmclMjBzaGluZXxlbnwwfHx8fDE3ODY1NjIxMDh8MA&ixlib=rb-4.1.0&q=85",
  retail:
    "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxib3V0aXF1ZSUyMHJldGFpbCUyMHN0b3JlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg2NTYyMTE4fDA&ixlib=rb-4.1.0&q=85",
  retailAlt:
    "https://images.unsplash.com/photo-1546213290-e1b492ab3eee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxib3V0aXF1ZSUyMHJldGFpbCUyMHN0b3JlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg2NTYyMTE4fDA&ixlib=rb-4.1.0&q=85",
};

export const PLANS = [
  {
    id: "starter",
    name: "Starter",
    price: 19,
    annualPrice: 190,
    tagline: "For small businesses getting started with consistent posting.",
    features: [
      "1 business",
      "30 AI content generations per month",
      "Up to 12 scheduled posts per month",
      "2 connected social accounts",
      "AI captions & content calendar",
      "Brand Profile & basic templates",
      "AutoSchedule",
      "Automatic publishing of approved content",
      "Email support",
    ],
    cta: "Start Starter",
  },
  {
    id: "grow",
    name: "Grow",
    price: 39,
    annualPrice: 390,
    badge: "MOST POPULAR",
    highlight: true,
    tagline: "For businesses that want a full month of content in one click.",
    features: [
      "1 business",
      "120 AI content generations per month",
      "Up to 30 scheduled posts per month",
      "Up to 4 connected social accounts",
      "Full PostMint Content Engine",
      "Monthly AI content plan",
      "AutoSchedule & automatic publishing",
      "Promotion Generator",
      "Content Repurposing",
      "Advanced templates",
      "AI visual tools (fair-use limits)",
      "Basic analytics",
      "Content feedback learning",
    ],
    cta: "Start Grow",
  },
  {
    id: "pro",
    name: "Pro",
    price: 79,
    annualPrice: 790,
    tagline: "For businesses that want social media heavily automated.",
    features: [
      "Up to 3 business locations or brands",
      "400 AI content generations per month",
      "Up to 100 scheduled posts per month",
      "Up to 10 connected social accounts",
      "Everything in Grow",
      "Advanced analytics",
      "Advanced AutoPilot",
      "Campaign Generator",
      "More AI visual generations",
      "Priority processing where available",
      "Advanced brand controls",
      "Priority support",
    ],
    cta: "Start Pro",
  },
];

// Kept as an alias so existing imports keep working.
export const PACKAGES = PLANS;

export const TRIAL = {
  days: 7,
  name: "Free Trial",
  headline: "Start your 7-day free trial",
  tagline:
    "Try everything in Grow free for 7 days. We ask for your card so your plan continues without interruption — you're charged nothing today, and you can cancel any time during the trial.",
  features: [
    "Full Grow features for 7 days",
    "60 AI content generations & 10 AI visuals",
    "Up to 12 scheduled posts and 2 connected accounts",
    "Monthly content plan, campaigns and publishing tools",
    "€0 today — cancel during the trial and you're never charged",
  ],
  afterwards:
    "When the 7 days are up, your Grow plan starts automatically at €39 per month excl. VAT and your card is charged. We email you before that happens. Cancel any time in Dashboard → Subscription and nothing is taken.",
  cta: "Start Free Trial",
};

export const MANAGED_SERVICE = {
  name: "PostMint Managed",
  fromPrice: 199,
  tagline: "Prefer someone else to run PostMint for you? Our team can do it.",
  features: [
    "Human content review before anything goes live",
    "Content adjustments by our team",
    "Campaign assistance",
    "Monthly optimisation",
    "Priority support",
  ],
  cta: "Contact Sales",
};

/**
 * Real customer quotes only. Add entries as you collect them (with permission):
 * { quote: "...", name: "Sanne", business: "Trattoria Rotterdam", city: "Rotterdam" }
 * While this list is empty, the homepage simply doesn't show a testimonials section —
 * we never invent quotes.
 */
export const TESTIMONIALS = [];

export const EXAMPLES = [
  {
    id: "restaurant-menu",
    industry: "Restaurant",
    business: "Neighbourhood restaurant",
    objective: "3-course dinner menu — €39.95",
    image: IMG.dinner,
    caption:
      "Three courses. One delicious evening. 🍽️\n\nEnjoy our special 3-course menu for €39.95 per person.\n\nPerfect for date night, dinner with friends or simply treating yourself.\n\nReserve your table today.",
    story: "Tonight's plans?\n3-course dinner\n€39.95\nReserve now →",
    reel:
      "Film 5 quick clips:\n1. restaurant exterior\n2. starter being plated\n3. main course arriving\n4. drinks being poured\n5. dessert close-up\n\nText overlay: 'Your next dinner date?'",
    promo: "Midweek dinner push: promote Tuesday–Thursday availability with a countdown story series.",
    hashtags: "#dinnerout #restaurantweek #foodlovers #reservenow",
    cta: "Reserve now",
  },
  {
    id: "barber-fade",
    industry: "Barber",
    business: "City centre barbershop",
    objective: "Fill weekday afternoon appointments",
    image: IMG.barber,
    caption:
      "Sharp fade. Fresh start. ✂️\n\nWeekday afternoons are our quietest hours — and our calmest chairs.\n\nBook your slot between 13:00 and 16:00 and walk out looking your best.",
    story: "Chair free today?\nYes.\n13:00 – 16:00\nBook now →",
    reel:
      "Film 4 clips:\n1. before shot in the mirror\n2. clipper close-up\n3. towel finish\n4. slow-motion reveal\n\nText overlay: 'Same guy. New week.'",
    promo: "Loyalty stamp reminder: every 5th cut includes a beard trim.",
    hashtags: "#barbershop #freshfade #menshair #bookyourcut",
    cta: "Book now",
  },
  {
    id: "salon-glow",
    industry: "Beauty",
    business: "Beauty & skincare salon",
    objective: "Promote a new glow facial treatment",
    image: IMG.salon,
    caption:
      "Skin that looks like you slept eight hours. ✨\n\nOur new Glow Facial deep-cleanses, hydrates and leaves your skin visibly brighter in 50 minutes.\n\nIntroductory price this month only.",
    story: "New treatment\nGlow Facial\n50 min\nBook your slot →",
    reel:
      "Film 5 clips:\n1. clean treatment room\n2. product texture close-up\n3. application detail\n4. client relaxing\n5. after-glow close-up\n\nText overlay: '50 minutes. Real difference.'",
    promo: "Introductory offer graphic + before/after carousel for the first four weeks.",
    hashtags: "#skincare #glowfacial #beautysalon #selfcare",
    cta: "Book now",
  },
  {
    id: "gym-january",
    industry: "Fitness",
    business: "Local gym & studio",
    objective: "Sign up new members for a 6-week programme",
    image: IMG.gym,
    caption:
      "Six weeks. One plan. Zero guesswork. 💪\n\nOur guided 6-week programme includes a personal intake, a training plan and weekly check-ins.\n\nLimited places per group — reserve yours.",
    story: "6-week programme\nSmall groups\nStarts Monday\nJoin now →",
    reel:
      "Film 5 clips:\n1. gym opening the doors\n2. warm-up drill\n3. heavy set close-up\n4. coach giving feedback\n5. high five finish\n\nText overlay: 'Week 1 vs week 6.'",
    promo: "Member transformation series with consent-based before/after posts.",
    hashtags: "#gymlife #6weekprogram #trainsmart #joinus",
    cta: "Join now",
  },
  {
    id: "cafe-seasonal",
    industry: "Café",
    business: "Speciality coffee bar",
    objective: "Launch a seasonal drink",
    image: IMG.latte,
    caption:
      "Meet the new seasonal favourite. ☕\n\nEspresso, oat milk and a hint of spiced honey — on the menu for the next six weeks.\n\nCome taste it before it disappears.",
    story: "New on the menu\nSpiced Honey Latte\nSix weeks only\nSwipe up →",
    reel:
      "Film 5 clips:\n1. beans being ground\n2. espresso pouring\n3. milk steaming\n4. latte art top-down\n5. first sip\n\nText overlay: 'Six weeks only.'",
    promo: "Pair with a lunch-deal graphic for weekday footfall.",
    hashtags: "#specialtycoffee #seasonaldrink #coffeebar #latteart",
    cta: "Visit us",
  },
  {
    id: "auto-detail",
    industry: "Automotive",
    business: "Car detailing studio",
    objective: "Promote a full paint correction package",
    image: IMG.car,
    caption:
      "The difference is in the reflection. 🚗\n\nOur full paint correction package removes swirls and restores depth to your paintwork.\n\nBook an inspection and we'll walk you through exactly what your car needs.",
    story: "Paint correction\nBefore → after\nBook inspection →",
    reel:
      "Film 4 clips:\n1. swirl marks under light\n2. polisher in action\n3. panel wipe-down\n4. mirror-finish reveal\n\nText overlay: 'Same car. Same day.'",
    promo: "Seasonal ceramic coating bundle with limited weekend slots.",
    hashtags: "#cardetailing #paintcorrection #ceramiccoating #detailingstudio",
    cta: "Book now",
  },
  {
    id: "retail-drop",
    industry: "Retail",
    business: "Independent clothing store",
    objective: "Announce a new collection drop",
    image: IMG.retail,
    caption:
      "The new drop just landed. 🛍️\n\nLimited pieces, in store and online from Friday.\n\nCome early — sizes go fast.",
    story: "New collection\nIn store Friday\nLimited pieces\nShop now →",
    reel:
      "Film 5 clips:\n1. boxes being opened\n2. rail being filled\n3. detail shots of fabric\n4. staff styling a look\n5. shop window reveal\n\nText overlay: 'Friday. In store.'",
    promo: "Early-access story series for newsletter subscribers.",
    hashtags: "#newcollection #shoplocal #newdrop #independentstore",
    cta: "Shop now",
  },
  {
    id: "hospitality-terrace",
    industry: "Hospitality",
    business: "Hotel bar & terrace",
    objective: "Fill the terrace on sunny afternoons",
    image: IMG.dinnerAlt,
    caption:
      "Sun's out. Terrace is open. 🍹\n\nCold drinks, small plates and the best afternoon light in the neighbourhood.\n\nNo reservation needed — just show up.",
    story: "Terrace open\nCold drinks\nSmall plates\nSee you soon →",
    reel:
      "Film 4 clips:\n1. terrace wide shot\n2. cocktail being poured\n3. plates arriving\n4. guests toasting\n\nText overlay: 'Best seat in town.'",
    promo: "Weather-triggered story template you can post whenever the sun appears.",
    hashtags: "#terrace #hotelbar #afternoondrinks #citybreak",
    cta: "Visit us",
  },
];

export const EXAMPLE_FILTERS = [
  "All",
  "Restaurant",
  "Café",
  "Beauty",
  "Barber",
  "Fitness",
  "Automotive",
  "Retail",
  "Hospitality",
];

export const SERVICES = [
  {
    title: "Social Media Posts",
    body: "Post concepts tailored to your business, products and audience.",
    icon: "LayoutGrid",
  },
  {
    title: "Caption Writing",
    body: "Professional captions matching your business's tone of voice.",
    icon: "PenLine",
  },
  {
    title: "Content Calendars",
    body: "A clear monthly posting schedule so you always know what goes out when.",
    icon: "CalendarDays",
  },
  {
    title: "Reel & TikTok Ideas",
    body: "Short-form video concepts including hook, video idea, shot list, text overlay, caption and call to action.",
    icon: "Clapperboard",
  },
  {
    title: "Promotional Content",
    body: "Content for special offers, events, new products, holiday campaigns, seasonal promotions, sales, menu changes and new services.",
    icon: "Megaphone",
  },
  {
    title: "Promotional Graphics",
    body: "Branded graphics designed for social media feeds and stories.",
    icon: "Image",
  },
  {
    title: "Review Responses",
    body: "Professional responses to Google reviews, Facebook reviews and customer feedback.",
    icon: "MessageSquareQuote",
  },
  {
    title: "Campaign Ideas",
    body: "Monthly marketing campaign concepts built around your goals.",
    icon: "Target",
  },
];

export const BUSINESS_TYPES = [
  {
    id: "restaurants",
    name: "Restaurants",
    image: IMG.dinner,
    items: [
      "menu items",
      "chef content",
      "special menus",
      "events",
      "cocktails",
      "terrace",
      "reservations",
      "seasonal offers",
      "behind the scenes",
    ],
  },
  {
    id: "cafes",
    name: "Cafés",
    image: IMG.barista,
    items: ["coffee", "lunch", "pastries", "seasonal drinks", "staff", "customer atmosphere", "offers"],
  },
  {
    id: "beauty",
    name: "Beauty Salons",
    image: IMG.salonAlt,
    items: [
      "before and after",
      "treatments",
      "appointments",
      "offers",
      "education",
      "beauty tips",
      "new products",
    ],
  },
  {
    id: "barbers",
    name: "Barbers",
    image: IMG.barberAlt,
    items: ["hair transformations", "cuts", "styling", "booking reminders", "products", "barber tips"],
  },
  {
    id: "gyms",
    name: "Gyms",
    image: IMG.gymAlt,
    items: ["workouts", "membership offers", "trainers", "classes", "transformations", "motivation"],
  },
  {
    id: "automotive",
    name: "Automotive",
    image: IMG.carAlt,
    items: ["car detailing", "before and after", "new stock", "services", "promotions", "tips"],
  },
];

export const PRICING_FAQ = [
  {
    q: "Is there really a free trial?",
    a: "Yes — 7 days with the full Grow feature set. We ask for a card so your plan carries on without interruption, but you pay €0 during the trial. When the trial ends, Grow starts automatically at €39 per month excl. VAT and we email you before the first charge. Cancel any time during the trial and you are not charged at all.",
  },
  {
    q: "What happens when my trial ends?",
    a: "Your account becomes read-only. You can still see, copy and export everything you created. The moment you choose Starter, Grow or Pro, everything switches back on — including any posts you had scheduled.",
  },
  {
    q: "Can I change plans?",
    a: "Yes. You can upgrade or downgrade from the Subscription page in your dashboard at any time.",
  },
  {
    q: "Can I cancel my subscription?",
    a: "Yes. You can cancel from your dashboard according to the subscription terms. We do not hide the cancellation option.",
  },
  {
    q: "What is an AI generation?",
    a: "One generation is one piece of content PostMint writes for you — a caption, a story concept, a Reel script or one post in a campaign. Your remaining allowance is always visible in your dashboard.",
  },
  {
    q: "What happens if I reach my monthly allowance?",
    a: "Nothing is deleted. You keep everything already created and can either upgrade, wait for your allowance to renew, or buy extra credits where that is supported.",
  },
  {
    q: "Does PostMint publish my posts automatically?",
    a: "Only after you approve them, and only to accounts you have connected. Automatic publishing is included on Starter, Grow and Pro.",
  },
  {
    q: "Why is annual billing cheaper?",
    a: "Annual plans are billed once for ten months of the monthly price, so you effectively get two months free. The exact saving is shown on each plan.",
  },
  {
    q: "Can you create content in Dutch?",
    a: "Yes. Dutch and English are both fully supported, and you can mix them or set a different language per post.",
  },
  {
    q: "Do I still need someone to make my content?",
    a: "No. That is the point of PostMint — normal customers never need a PostMint employee to build their month. If you would still prefer human help, PostMint Managed is available separately.",
  },
  {
    q: "Are the prices including VAT?",
    a: "Prices shown on this website are business prices excluding VAT where VAT legally applies. Your invoice shows the exact VAT treatment according to our final tax setup.",
  },
];

export const GENERAL_FAQ = [
  {
    q: "What is PostMint?",
    a: "PostMint is a social media content service for businesses. We help create social media ideas, captions, promotional posts, content calendars and short-form video concepts.",
  },
  {
    q: "Is PostMint an AI tool?",
    a: "PostMint uses modern technology and AI-assisted workflows to help create content efficiently, but all services are designed around each customer's individual business and content needs.",
  },
  {
    q: "Will my content look generic?",
    a: "No. Customers complete a detailed Brand Profile that helps tailor content to their business, audience, tone and services.",
  },
  {
    q: "Can I request changes?",
    a: "Yes. Revision allowances depend on the selected package.",
  },
  {
    q: "Do you automatically publish my posts?",
    a: "Initially, customers receive their content to review and publish themselves unless automatic scheduling is separately offered.",
  },
  { q: "Can you work with my existing photos?", a: "Yes." },
  { q: "Can I upload videos?", a: "Yes. MP4 and MOV files are supported in your dashboard." },
  {
    q: "Can I send you promotions during the month?",
    a: "Yes. Submit new promotions at any time through the Promotions page in your dashboard and we will factor them into your content.",
  },
  {
    q: "What languages can you create content in?",
    a: "Dutch and English are the main options. You can also request bilingual content.",
  },
  {
    q: "Are the prices including VAT?",
    a: "Prices shown on this website are business prices excluding VAT where VAT legally applies. Your invoice shows the exact VAT treatment according to our final tax setup.",
  },
  {
    q: "How quickly do I receive my content?",
    a: "Delivery timelines are shown during onboarding and may depend on your package and the completeness of the materials you provide. We do not promise unrealistic turnaround times.",
  },
];

export const INDUSTRY_OPTIONS = [
  "Restaurant",
  "Café",
  "Bar",
  "Beauty Salon",
  "Barber",
  "Gym",
  "Fitness Studio",
  "Automotive",
  "Retail",
  "Hotel",
  "Hospitality",
  "Professional Services",
  "Other",
];

export const CONTENT_STATUSES = [
  "Information Required",
  "Content Being Prepared",
  "Ready for Review",
  "Changes Requested",
  "Changes In Progress",
  "Approved",
  "Completed",
];

export const ADMIN_STATUSES = [
  "Draft",
  "Needs Review",
  "Ready for Customer",
  "Customer Reviewing",
  "Revision Requested",
  "Approved",
  "Completed",
];
